import { createGlobalStyle } from 'styled-components';
import { colorHexToRgba } from '../helpers/styled-color-opacity';
import { ThemeType } from './theme';
import warningFilledIcon from '../assets/svg/ic_warning.svg?url';

const GlobalStyle = createGlobalStyle<{ theme: ThemeType }>`
  body {
    font-family: ${({ theme }) => {
      return `${theme.fontFamily}, ${theme.defaultFontFamily}`;
    }};
    color: ${({ theme }) => theme.palette.text.primary};
  }

  .ant-layout {
    background: ${props => props.theme.palette.background.light};
  }

  // SPINNER/LOADER
  .ant-spin {
    &-dot-item {
      background-color: ${props => props.theme.palette.primary.main};
    }
  }

  // POPOVER
  .ant-popover {
    &-arrow {
      border-color: ${({ theme }) => theme.palette.text.primary} !important; 
    }

    &-inner {
      background: ${({ theme }) => theme.palette.text.primary};

      &-content{ 
        color: ${({ theme }) => theme.palette.text.light};
      }
    }
  }

  // TOOLTIP
  .ant-tooltip {
    &-arrow {
      border-color: ${({ theme }) => theme.palette.text.primary80} !important; 
    }

    &-inner {
      background: ${({ theme }) => theme.palette.text.primary80};
      font-size: 14px;
      line-height: 1.3;

      &-content{ 
        color: ${({ theme }) => theme.palette.text.light};
      }
    }
  }

  // MODAL
  .ant-modal-root {
    .ant-modal {
      &-mask {
        background-color: ${({ theme }) =>
          colorHexToRgba(theme.palette.text.primary, 0.5)};
      }

      &-header {
        border-radius: 10px 10px 0 0;
        border: none;
      }

      &-content {
        border-radius: 10px;
        box-shadow: none;
      }

      &-footer {
        text-align: center;
      }
    }
  }
  .userlistmodal {    
    .ant-modal-content {
      padding: 24px;
    }
    .ant-modal-footer {
      margin-top: 24px;
      padding: 0;
      border: none;      
    }
    .ant-modal-body {
      padding: 0;
      p {
        margin-bottom: 0;
        padding-top: 16px;     
      }
    }
  }

  // BUTTON
  .ant-btn {
    min-width: 200px;
  }

  // FORM
  .ant-form-item-has-error :not(.ant-input-disabled).ant-input,
  .ant-form-item-has-error :not(.ant-input-affix-wrapper-disabled).ant-input-affix-wrapper,
  .ant-form-item-has-error :not(.ant-input-disabled).ant-input:hover,
  .ant-form-item-has-error :not(.ant-input-affix-wrapper-disabled).ant-input-affix-wrapper:hover {
    border-color: ${props => props.theme.palette.text.attention} !important;
  }
  .ant-form-item-has-error :not(.ant-input-disabled).ant-input:focus,
  .ant-form-item-has-error :not(.ant-input-affix-wrapper-disabled).ant-input-affix-wrapper:focus,
  .ant-form-item-has-error :not(.ant-input-disabled).ant-input-focused,
  .ant-form-item-has-error :not(.ant-input-affix-wrapper-disabled).ant-input-affix-wrapper-focused {
    border-color: ${props => props.theme.palette.text.attention};
    box-shadow: 0 0 0 2px ${props => props.theme.palette.text.attention15};
  }
  .ant-form-item-has-error {
    .ant-form-item-split {
      color: ${props => props.theme.palette.text.attention};
    }
    .ant-calendar-picker-open {
      .ant-calendar-picker-input {
        border-color: ${props => props.theme.palette.text.attention};
        box-shadow: 0 0 0 2px ${props => props.theme.palette.text.attention15};
      }
    }
    .ant-input-prefix {
      color: ${props => props.theme.palette.text.attention};
    }
    .ant-input-group-addon {
      color: ${props => props.theme.palette.text.attention};
      border-color: ${props => props.theme.palette.text.attention};
    }
    .has-feedback {
      color: ${props => props.theme.palette.text.attention};
    }
    .ant-select {
      &:not(.ant-select-disabled) {
        &:not(.ant-select-customize-input) {
          .ant-select-selector {
            border-color: @attention !important;
          }
        }
        &:not(.ant-select-customize-input).ant-select-open {
          .ant-select-selector {
            border-color: ${props => props.theme.palette.text.attention};
            box-shadow: 0 0 0 2px ${props =>
              props.theme.palette.text.attention15};
          }
        }
        &:not(.ant-select-customize-input).ant-select-focused {
          .ant-select-selector {
            border-color: ${props => props.theme.palette.text.attention};
            box-shadow: 0 0 0 2px ${props =>
              props.theme.palette.text.attention15};
          }
        }
      }
    }
    .ant-select.ant-select-auto-complete {
      .ant-input {
        &:focus {
          border-color: ${props => props.theme.palette.text.attention};
        }
      }
    }
    .ant-input-number {
      border-color: ${props => props.theme.palette.text.attention};
      &:focus {
        border-color: ${props => props.theme.palette.text.attention};
        box-shadow: 0 0 0 2px ${props => props.theme.palette.text.attention15};
      }
      &:not([disabled]) {
        &:hover {
          border-color: ${props => props.theme.palette.text.attention};
        }
      }
    }
    .ant-picker {
      border-color: ${props => props.theme.palette.text.attention};
      &:focus {
        border-color: ${props => props.theme.palette.text.attention};
        box-shadow: 0 0 0 2px ${props => props.theme.palette.text.attention15};
      }
      &:not([disabled]) {
        &:hover {
          border-color: ${props => props.theme.palette.text.attention};
        }
      }
    }
    .ant-input-number-focused {
      border-color: ${props => props.theme.palette.text.attention};
      box-shadow: 0 0 0 2px ${props => props.theme.palette.text.attention15};
    }
    .ant-picker-focused {
      border-color: ${props => props.theme.palette.text.attention};
      box-shadow: 0 0 0 2px ${props => props.theme.palette.text.attention15};
    }
    .ant-cascader-picker {
      &:hover {
        .ant-cascader-picker-label {
          &:hover {
            & + .ant-cascader-input.ant-input {
              border-color: ${props => props.theme.palette.text.attention};
            }
          }
        }
      }
      &:focus {
        .ant-cascader-input {
          border-color: ${props => props.theme.palette.text.attention};
          box-shadow: 0 0 0 2px ${props =>
            props.theme.palette.text.attention15};
        }
      }
    }
    .ant-radio-button-wrapper {
      border-color: @attention !important;
      &:not(:first-child) {
        &::before {
          background-color: ${props => props.theme.palette.text.attention};
        }
      }
    }
  }
  .ant-form-item-has-error.ant-form-item-has-feedback {
    .ant-form-item-children-icon {
      color: ${props => props.theme.palette.text.attention};
    }
  }
  
  .ant-form-item-explain {
    font-size: 14px;
    margin-bottom: 5px;
    color: ${props => props.theme.palette.text.attention};
    background-image: url("${warningFilledIcon}");
    background-repeat: no-repeat;
    padding-left: 20px;
    background-position: 0px 4px;
  }
  
  .ant-form-item-label
    > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
    color: ${props => props.theme.palette.text.attention};
  }
  .ant-table-empty{
    .ant-table-placeholder:hover{
      td{
        background: transparent !important;
      }
    }
  }
 
  .ant-table {
    .ant-table-tbody > tr.highlight-row {        
      > td.ant-table-column-sort {
        background: ${({ theme }) => theme.palette.success15};
      }
      > td {
        background: ${({ theme }) => theme.palette.success15};
      }
    }
  }
  

  // TEXTFIELD
  .ant-input {
    border: 1px solid ${props => props.theme.palette.border};
    border-radius: 4px;
    height: 36px;

    &:hover, &:focus {
      border: 1px solid ${props => props.theme.palette.primary.main};      
    }
    &:focus{
      box-shadow: 0 0 0 2px ${props => props.theme.palette.text.purple40};
    }

    &-password {
      border: 1px solid ${props => props.theme.palette.border};
      border-radius: 3px;
      height: 36px;
      padding: 0 10px;
      box-shadow: none;

      .ant-input {
        padding: 0;
        background: transparent !important;
      }
    }

    &-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
      border: 1px solid ${props => props.theme.palette.primary.main};
    }

    &-affix-wrapper-borderless {
      border: none !important;
    }
  }



  // SELECT 
  .ant-select {
    &:not(.ant-select-customize-input) .ant-select-selector {
      border: 1px solid ${props => props.theme.palette.border};
      height: 36px;
      border-radius: 4px;

      &:hover, &:focus {
        border: 1px solid ${props => props.theme.palette.primary.main};
        box-shadow: none;
      }

      input {
        height: 36px !important;
      }

      .ant-select-selection-item, .ant-select-selection-placeholder {
        line-height: 36px;
      }
    }

    &-focused {
      &:not(.ant-select-customize-input) .ant-select-selector {
        border: 1px solid ${props =>
          props.theme.palette.primary.main} !important;        
      }
    }

   

    .ant-select-selection-overflow {
      height: 36px;
      margin-top: -2px;

      &-item {
        margin-top: -2px;

        .ant-select-selection-item {
          height: 28px;
          line-height: 28px !important;
          border-radius: 14px;
          border: none;
          padding: 0 15px;
          background: ${props => props.theme.palette.primary.light};

          .ant-select-selection-item-remove {
            height: 17px;
            display: flex;
            align-items: center;
            align-self: center;
            width: 17px;
            border-radius: 50%;
            justify-content: center;
            margin-right: -5px;
            background: rgba(0, 0, 0, 0.25);

            .anticon {
              color: ${props => props.theme.palette.primary.light};
              margin-top: 2px;
              font-weight: bold;
              font-size: 9px;
            }
          }
        }
      }
    }
  }
  
  // CHECKBOX
  .ant-checkbox-wrapper:hover .ant-checkbox-inner,
  .ant-checkbox:hover .ant-checkbox-inner {
    border-color: ${props => props.theme.palette.primary.main};
  }
  .ant-checkbox-wrapper {
    .ant-checkbox-input:focus + .ant-checkbox-inner {
      border-color: ${props => props.theme.palette.primary.main};
    }

    .ant-checkbox-checked {
      &::after {
        border: 1px solid ${props => props.theme.palette.primary.main};
      }
      .ant-checkbox-inner {
        background-color: ${props => props.theme.palette.primary.main};
        border-color: ${props => props.theme.palette.primary.main};
      }
    }
  
    .ant-checkbox-inner {
      background-color: ${props => props.theme.palette.background.light};
      border: 1px solid ${props => props.theme.palette.text.grey};
    }
  
    .ant-checkbox-disabled {
      .ant-checkbox-inner {
        background-color: ${props => props.theme.palette.background.secondary};
        border-color: ${props => props.theme.palette.border} !important;
        &::after {
          border-color: ${props => props.theme.palette.background.secondary};
        }
      }
  
      &.ant-checkbox-checked {
        .ant-checkbox-inner {
          &::after {
            border-color: ${props => props.theme.palette.background.grey2};
          }
        }
      }
  
      &.ant-checkbox-indeterminate {
        .ant-checkbox-inner {
          &::after {
            background: ${props => props.theme.palette.background.grey2};
          }
        }
      }
    }
  
    .ant-checkbox-indeterminate {
      .ant-checkbox-inner {
        background-color: ${props => props.theme.palette.background.light};
        border-color: ${props => props.theme.palette.primary.main};
        &::after {
          background-color: ${props => props.theme.palette.primary.main};
        }
      }
    }
  }

  // RADIO
  .ant-radio-wrapper {
    .ant-radio {
      &-wrapper-checked {
        font-weight: bold;
      }
      &.ant-radio-checked {
        .ant-radio-inner {
          background-color: ${props => props.theme.palette.background.light};
          border-color: ${props => props.theme.palette.primary.main};
          &::after {
            background-color: ${props => props.theme.palette.primary.main};
          }
        }
      }
      &.ant-radio-disabled {
        .ant-radio-inner {
          background-color: ${props =>
            props.theme.palette.background.secondary};
          border-color: ${props => props.theme.palette.border} !important;
          &::after {
            background-color: ${props => props.theme.palette.background.grey2};
          }
        }
      }
      .ant-radio-inner {
        background-color: ${props => props.theme.palette.background.light};
        border-color: ${props => props.theme.palette.text.grey};
      }
    }
  }

  .ant-radio-input:focus + .ant-radio-inner{
    box-shadow: none;
  }
  .ant-checkbox-input:focus + .ant-checkbox-inner{
    border-color:#d9d9d9;
  }
  .emptyuserblock:hover{
    background: transparent;
  }
  // LIST
  .ant-list {
    &-item:hover {
      background: ${props => props.theme.palette.primary.light};
    }
  }

  // DATEPICKER
  .ant-picker {
    border: 1px solid ${props => props.theme.palette.border};
    border-radius: 4px;

    &:hover, &-focused {
      border: 1px solid ${props => props.theme.palette.primary.main};
      box-shadow: none;
    }

    &-suffix .anticon {
      color: ${props => props.theme.palette.primary.main};
    }

    &-now-btn {
      color: ${props => props.theme.palette.primary.main};

      &:hover {
        color: ${props => props.theme.palette.primary.main};
      }
    }

    &-footer {
      button {
        border-radius: 20px;
        min-width: 70px;
      }
    }

    &-time-panel-column > li.ant-picker-time-panel-cell-selected .ant-picker-time-panel-cell-inner {
        background: ${props => props.theme.palette.primary.light};
      }
    }
  }

  .ant-picker-dropdown { 
    .ant-picker-header-view {
      font-weight: normal;

      button {
        font-weight: normal;

        &:hover, &:focus, &:active {
          color: ${props => props.theme.palette.primary.main};
        }
      }
    }

    .ant-picker-body {
      // date today
      .ant-picker-cell-today .ant-picker-cell-inner::before {
        border: 1px solid ${props => props.theme.palette.primary.main};
      }

      .ant-picker-cell-in-view {
        // selected
        &.ant-picker-cell-selected, 
        &.ant-picker-cell-range-start, 
        &.ant-picker-cell-range-end {

          .ant-picker-cell-inner {
            background: ${props => props.theme.palette.primary.main};
          }

          &:before {
            background: ${props =>
              props.theme.palette.primary.light} !important;
          }

          &.ant-picker-cell-range-start-single,
          &.ant-picker-cell-range-start-end {
            &:before {
              background: none !important;
            }
          }

          &.ant-picker-cell-range-hover-start,
          &.ant-picker-cell-range-hover,
          &.ant-picker-cell-range-hover-end {
            &:before {
              background: ${props =>
                props.theme.palette.text.purple40} !important;
            }
          }
        }

        &.ant-picker-cell-range-hover-start,
        &.ant-picker-cell-range-hover,
        &.ant-picker-cell-range-hover-end {
          &:after {
            border-color: ${props =>
              props.theme.palette.text.purple40} !important;
          }
        }

        // in range
        &.ant-picker-cell-in-range {
          &:before {
            background: ${props =>
              props.theme.palette.primary.light} !important;
          }

          &.ant-picker-cell-range-hover-start,
          &.ant-picker-cell-range-hover,
          &.ant-picker-cell-range-hover-end {
            &:before {
              background: ${props =>
                props.theme.palette.text.purple40} !important;
            }
          }

          &:hover {
            .ant-picker-cell-inner:after {
              background: ${props =>
                props.theme.palette.text.purple40} !important;
            }
          }
        }
      }
      
      // disabled
      .ant-picker-cell-disabled {
        &.ant-picker-cell-today .ant-picker-cell-inner::before {
          border: 1px solid ${props => props.theme.palette.border} !important;
        }
      }
    }

    .ant-picker-footer {
      .ant-picker-preset span {
        border: 1px solid ${props => props.theme.palette.background.grey2};
        background: ${props => props.theme.palette.background.light};
        height: 36px;
        border-radius: 18px;
        font-size: 16px;
        padding: 0 15px;
        color: ${props => props.theme.palette.text.primary60};
        display: flex;
        align-items: center;
        color: ${props => props.theme.palette.text.grey};
      }
      .ant-picker-today-btn {
        color: ${props => props.theme.palette.primary.main};
      }
    }
  }
  .required-input{
    padding-left:20px;
  }
  .custom-apikey{
    .text-wrap{
      word-break: break-all;
    }
  }
  .link {
    color:${props => props.theme.palette.background.purpleDarkened1};
    &:hover {
      color: ${props => props.theme.palette.icon.purple};
      text-decoration: underline;
    }
    &:active {
      color: ${props => props.theme.palette.primary.dark};
      text-decoration: underline;
    }
  }
`;

export default GlobalStyle;
